import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type PasswordChangeState = {
    userPw: string;
    userPwNew: string;
    userPwCheck: string;
    isModalOpen: boolean;
}

const initialState: PasswordChangeState = {
    userPw: "",
    userPwNew: "",
    userPwCheck: "",
    isModalOpen: false,
}

const passwordChangeSlice = createSlice({
    name: "passwordChange",
    initialState,
    reducers: {
        setUserPw: (state, action: PayloadAction<string>) => {
            state.userPw = action.payload;
        },
        setUserPwNew: (state, action: PayloadAction<string>) => {
            state.userPwNew = action.payload;
        },
        setUserPwCheck: (state, action: PayloadAction<string>) => {
            state.userPwCheck = action.payload;
        },
        setIsModalOpen: (state, action: PayloadAction<boolean>) => {
            state.isModalOpen = action.payload;
        },
        resetPasswordChange: (state) => {
            state.userPw = "";
            state.userPwNew = "";
            state.userPwCheck = "";
            state.isModalOpen = false;
        },
    },
});

export const {
    setUserPw,
    setUserPwNew,
    setUserPwCheck,
    setIsModalOpen,
    resetPasswordChange,
} = passwordChangeSlice.actions;

const passwordChangeReducer = passwordChangeSlice.reducer;
export default passwordChangeReducer;

